function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import TiTroviIn from "@/widget/TiTroviIn";
import LogoParita from "../../../img/logoheaderpage.png";
import "../../../../css/Faq.css";
var listaFaq = [{
  "title": "Il Sistema di Gestione della Parità di Genere è applicabile a tutte le categorie merceologiche di aziende (es. anche ambito costruzioni)?",
  "text": "Si conferma che il Sistema di Gestione ai sensi della UNI/PdR 125:2022 è applicabile a tutte le organizzazioni pubbliche e private di ogni dimensione e settore. ",
  "category": 1
}, {
  "title": "Le certificazioni svolte da organismi di certificazione non accreditati danno la possibilità alle imprese di accedere ai benefici fiscali previsti dalle leggi in materia, perché le uniche riconosciute dal decreto del Ministro per le pari opportunità e la famiglia del 29 aprile 2022?",
  "text": "No, solo le certificazioni rilasciate da organismi di certificazione accreditati ai sensi del Reg. (CE) n. 765/08 e quindi riportanti il marchio UNI e quello dell’Ente di accreditamento, sono valide ai fini del riconoscimento per le imprese dei benefici stabiliti dal Legislatore.  ",
  "category": 2
}, {
  "title": "Il rapporto periodico sul personale femminile e maschile, ex art. 46 del decreto legislativo n. 198/2006 (Codice pari opportunità), dà automaticamente origine alla certificazione della parità di genere?",
  "text": "No, il rapporto periodico sul personale femminile e maschile non dà origine automaticamente alla certificazione della parità di genere. In base all’art 46bis del Codice delle pari opportunità, che regola la certificazione della parità di genere, nonché in base al decreto del Ministro per le pari opportunità e la famiglia del 29 aprile 2022, la certificazione è rilasciata da organismi di certificazione accreditati al rilascio della certificazione in conformità alla Prassi UNI/PdR 125:2022 ed è richiesta su base volontaria dalle imprese.",
  "category": 3
}, {
  "title": "Il rapporto periodico sulla situazione del personale maschile e femminile, ex art. 46 del decreto legislativo 11 aprile 2006, n. 198 (Codice pari opportunità), e l’informativa aziendale sul grado di adeguamento alla prassi UNI/PdR 125:2022, di cui al decreto della Ministra per le pari opportunità del 29 aprile 2022 sono la stessa cosa?",
  "text": "Il rapporto è un obbligo informativo per le aziende pubbliche e private con più di cinquanta dipendenti nel proprio organico che viene caricato sulla piattaforma Equalmonitor del Ministero del lavoro e delle politiche sociali. L’informativa, invece, è un onere a carico del datore di lavoro per consentire il controllo e la verifica, da parte delle rappresentanze sindacali aziendali e delle consigliere e consiglieri territoriali e regionali di parità, del rispetto dei parametri minimi che hanno consentito all’azienda di ottenere la certificazione della parità di genere. ",
  "category": 4
}];
var Faq = observer(function (props) {
  var rootStore = useContext(StoreContext).rootStore;
  var _useState = useState(listaFaq),
    _useState2 = _slicedToArray(_useState, 2),
    faqs = _useState2[0],
    setFaqs = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    faqsPerCategory = _useState4[0],
    setFaqsPerCategory = _useState4[1];
  var BREADCRUMB_TITOLO = "FAQ";
  var BREADCRUMB_CHILDREN = [{
    to: process.env.CONTEXT_PATH + "/home",
    label: "Home"
  }];
  var breadcrumb = /*#__PURE__*/React.createElement(TiTroviIn, {
    children: BREADCRUMB_CHILDREN,
    title: BREADCRUMB_TITOLO
  });
  var $ = require("jquery");
  useEffect(function () {
    document.title = "Certificazione della parità di genere - FAQ";
    $("#ita.list-inline-item").addClass("active");
    $("#eng.list-inline-item").removeClass("active");
  });
  useEffect(function () {
    if (faqsPerCategory.length === 0) {
      var _faqsPerCategory = {};
      listaFaq.map(function (faq) {
        _faqsPerCategory[faq.category] = listaFaq.filter(function (faqFilter) {
          return faqFilter.category === faq.category;
        });
      });
      setFaqs(faqs);
      setFaqsPerCategory(_faqsPerCategory);
    }
  });
  var searchFaqs = function searchFaqs(event) {
    var value = event.target.value;
    var newFaqus = faqs.filter(function (faq) {
      return faq.title.toLowerCase().includes(value.toLowerCase());
    });
    var faqsPerCategory = {};
    newFaqus.map(function (faq) {
      faqsPerCategory[faq.category] = newFaqus.filter(function (faqFilter) {
        return faqFilter.category === faq.category;
      });
    });
    setFaqsPerCategory(faqsPerCategory);
  };
  return rootStore.uiStore.numberCallback === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "postizioneLogoHeader"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoParita,
    alt: "",
    className: "img-fluid dimImage",
    width: "500"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, breadcrumb, /*#__PURE__*/React.createElement("div", {
    className: "row altezzaMin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h2", null, "FAQ"), /*#__PURE__*/React.createElement("p", null, " Per informazioni, segnalazioni e quesiti sul Sistema nazionale di certificazione della parit\xE0 di genere alle imprese \xE8 possibile rivolgersi a ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:certificazione.pariopportunita@governo.it",
    target: "_blank"
  }, "certificazione.pariopportunita@governo.it"), ".", /*#__PURE__*/React.createElement("br", null), " Al seguente ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.uni.com/le-nuove-faq-sulla-parita-di-genere-nelle-organizzazioni/",
    target: "_blank"
  }, "link"), " \xE8 possibile consultare le FAQ, elaborate da UNI ed ACCREDIA, sulla Prassi di Riferimento UNI/PdR 125:2022 \"Linee guida sul sistema di gestione per la parit\xE0 di genere che prevede l\u2019adozione di specifici KPI (Key Performances Indicator - Indicatori chiave di prestazione) inerenti alle Politiche di parit\xE0 di genere nelle organizzazioni\"."))))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 offset-lg-6 col-sm-12"
  }, /*#__PURE__*/React.createElement("form", {
    name: "",
    action: "",
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "...",
    className: "sr-only"
  }, "Cerca:"), /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "...",
    name: "...",
    className: "form-control",
    placeholder: "Cerca...",
    onChange: searchFaqs
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-search"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Cerca"))))))), /*#__PURE__*/React.createElement("div", {
    "data-bs-spy": "scroll",
    "data-bs-target": "#list-example",
    "data-bs-smooth-scroll": "true",
    className: "scrollspy-example"
  }, Object.keys(faqsPerCategory).map(function (faqCat, index) {
    if (faqCat.length > 0) return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "mt-5"
    }, /*#__PURE__*/React.createElement("h3", {
      id: "list-item-".concat(faqCat)
    }, "FAQ N. ", faqCat), /*#__PURE__*/React.createElement("div", null, faqsPerCategory[faqCat].map(function (faq, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "card card-default card-collapsible-reverse"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-header"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "card-title d-flex align-items-center justify-content-between"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#collapse-reverse-".concat(faqCat, "-").concat(index),
        className: "d-flex justify-content-between align-items-center collapsed custom-collapse-title text-decoration-none",
        "data-toggle": "collapse",
        "aria-expanded": "false",
        "aria-controls": "collapse-reverse-".concat(index)
      }, faq.title), /*#__PURE__*/React.createElement("i", {
        className: "fas fa-chevron-down custom-collapse-title"
      }))), /*#__PURE__*/React.createElement("div", {
        id: "collapse-reverse-".concat(faqCat, "-").concat(index),
        className: "collapse"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/React.createElement("p", {
        className: "custom-collapse-text"
      }, faq.text))));
    })));
  }))))));
});
export default Faq;